/**
 * @generated SignedSource<<5b1b8e8c8a661c6fd01fd23b0d2ef275>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectExtendRootNodesTabs_NodeFragment$data = {
  readonly id: string;
  readonly structureDefinition: {
    readonly extension?: {
      readonly elementsPoolId?: string;
    };
  };
  readonly " $fragmentType": "ProjectExtendRootNodesTabs_NodeFragment";
};
export type ProjectExtendRootNodesTabs_NodeFragment$key = {
  readonly " $data"?: ProjectExtendRootNodesTabs_NodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectExtendRootNodesTabs_NodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectExtendRootNodesTabs_NodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "extension",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "elementsPoolId",
                      "storageKey": null
                    }
                  ],
                  "type": "RootExtensionImpl",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "RootStructureDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "ad1ac92d70640b14e3d1f95e75022093";

export default node;
